import { render, staticRenderFns } from "./MiembrosTribunalPage.vue?vue&type=template&id=63b053f2"
import script from "./MiembrosTribunalPage.js?vue&type=script&lang=js&external"
export * from "./MiembrosTribunalPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports